// Unsent composer text, kept per room for the life of the app session. Leaving a
// room (Back button or edge swipe) unmounts ChatRoomScreen and used to throw the
// draft away; with a back gesture that's easy to trigger by accident, that
// stings. In memory only: a draft is not worth persisting across launches, and
// keeping it out of storage means nothing lingers on a shared device. Room ids
// are globally unique, so one map serves every household. Cleared on logout.

const drafts = new Map<string, string>()

export function getChatDraft(roomID: string): string {
  return drafts.get(roomID) ?? ''
}

export function setChatDraft(roomID: string, text: string): void {
  if (text.trim()) drafts.set(roomID, text)
  else drafts.delete(roomID)
}

export function clearChatDrafts(): void {
  drafts.clear()
}
